export enum HttpStatusCodes {
  OK = 200,
  UNPROCESSABLE_ENTITY = 422,
  INTERNAL_SERVER_ERROR = 500,
  NOT_FOUND = 404,
}
